import React from 'react';
import { Navbar } from 'react-bootstrap';
import axios from './../../../constants/axios';
import alert from 'alertify.js';
import { Link, IndexLink } from 'react-router';

class Product extends React.Component {
   generateBarcode = (e) => {
      e.preventDefault();
      axios.get(`items/generateBarcode`)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Barcode Generated.');
            } else {
               alert.error('Something Went Wrong.');
            }
         });
   };

   render() {
      return (
         <div>
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/product/" activeStyle={{ color: 'red' }} >Products</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li>
                     <Link to="/product/all" activeStyle={{ color: 'red' }} >All</Link>
                  </li>
                  <li>
                     <Link to="/product/newProduct" activeStyle={{ color: 'red' }} >New</Link>
                  </li>
                  <li>
                     <a href="#" onClick={(e) => this.generateBarcode(e)} >GenerateBarcode</a>
                  </li>
                  <li>
                     <IndexLink to="/product" activeStyle={{ color: 'red' }} >Product Search</IndexLink>
                  </li>
               </ul>

            </Navbar>
            {this.props.children}
         </div>
      );
   }
}
Product.propTypes = {
   children: React.PropTypes.object
};
export default Product;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/Product.js
 **/